const HeaderScroll = () => {

    // Header element
    const header_element = document.querySelector('.header');
    // Mobile menu selector
    const mobile_menu = document.querySelector('.mobile-menu');
    // Modifier class for the scrolled menu state
    const scrolled_class = 'header--scrolled';
    // Modifier for the scrolled mobile menu state
    const mobile_class = 'mobile-menu--scrolled';

    // Add or remove classes based on the user scrolling down the page
    window.addEventListener('scroll', () => {
        
        const current_scroll = window.pageYOffset;

        if (current_scroll > 0) {
            header_element.classList.add(scrolled_class);

            if (typeof mobile_menu != 'undefined' && mobile_menu) {
                mobile_menu.classList.add(mobile_class);
            }
        } else {
            header_element.classList.remove(scrolled_class);
            
            if (typeof mobile_menu != 'undefined' && mobile_menu) {
                mobile_menu.classList.remove(mobile_class);
            }
        }
    });
}

export default HeaderScroll;